import React, { useMemo } from "react";

import {
  FaClock,
  FaEuroSign,
  FaShoppingCart,
} from "react-icons/fa";

import { DashboardCard, SectionHeader, StatCard } from "../ui/DashboardUI";

import { cf, nf } from "../utils/dashboard.utils";

import ReglementsCrud from "./ReglementsCrud";

export default function AbonnementsSection({
  stats,
  reglements,
  users,
  clubsByUser,
  loadingStats,
  loadingReglements,
  loadingUsers,
  loadingClubs,
  saving,
  onLoadUserClub,
  onCreate,
  onUpdate,
  onDelete,
}) {
  const details = useMemo(() => {
    return Object.entries(stats?.detail || {}).sort(
      (first, second) => Number(second[1] || 0) - Number(first[1] || 0),
    );
  }, [stats]);

  return (
    <section className="mb-6">
      <SectionHeader
        title="Abonnements"
        subtitle="Revenus, renouvellements et gestion complète des achats."
      />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard
          label="Total encaissé"
          value={cf.format(Number(stats?.total_encaisse ?? stats?.total ?? 0))}
          icon={FaEuroSign}
          tone="emerald"
          loading={loadingStats}
          sub={`${nf.format(stats?.nombre_regles || 0)} achat(s) réglé(s)`}
        />

        <StatCard
          label="En attente"
          value={cf.format(Number(stats?.total_en_attente || 0))}
          icon={FaClock}
          tone="amber"
          loading={loadingStats}
          sub={`${nf.format(stats?.nombre_en_attente || 0)} règlement(s)`}
        />

        <StatCard
          label="Nombre d’achats"
          value={nf.format(stats?.nombre_achats || 0)}
          icon={FaShoppingCart}
          tone="blue"
          loading={loadingStats}
          sub="Tous statuts confondus"
        />
      </div>

      <DashboardCard className="mt-4 p-4 sm:p-5">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
            Chiffre d’affaires par formule
          </div>

          <div className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Seuls les achats réglés sont comptabilisés.
          </div>
        </div>

        {loadingStats ? (
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="h-20 animate-pulse rounded-xl bg-slate-200/70 dark:bg-slate-800"
              />
            ))}
          </div>
        ) : details.length > 0 ? (
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {details.map(([formula, amount]) => (
              <div
                key={formula}
                className="rounded-xl border border-slate-200/70 bg-slate-50/70 p-4 transition hover:shadow-sm dark:border-slate-800 dark:bg-slate-950/30"
              >
                <div className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                  {formula}
                </div>

                <div className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
                  {cf.format(Number(amount || 0))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-4 rounded-xl border border-dashed border-slate-300 px-4 py-8 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
            Aucun abonnement réglé n’est enregistré.
          </div>
        )}
      </DashboardCard>

      <ReglementsCrud
        reglements={reglements}
        users={users}
        clubsByUser={clubsByUser}
        loading={loadingReglements}
        clubsLoading={loadingClubs}
        usersLoading={loadingUsers}
        saving={saving}
        onLoadUserClub={onLoadUserClub}
        onCreate={onCreate}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    </section>
  );
}
